import React, { useEffect } from 'react';

const Notification = ({ message, type, onClear }) => {
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => onClear(), 4000);
            return () => clearTimeout(timer);
        }
    }, [message, onClear]);

    if (!message) return null;
    const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
    return (
        <div className={`fixed bottom-5 left-1/2 -translate-x-1/2 px-6 py-3 rounded-lg text-white font-semibold ${bgColor} shadow-lg z-50 print:hidden`}>
            {message}
        </div>
    );
};

export default Notification;
